<template>
  <div>
    <div :class="`my-4 v-label theme--${theme}`">Primary</div>
    <v-color-picker
      v-model="primaryColour"
      dot-size="25"
      swatches-max-height="200"
      elevation="5"
      hide-inputs
    ></v-color-picker>
  </div>
</template>

<script>
import { mapActions } from "vuex";

export default {
  // data: () => ({
  //   customTheme: false,
  //   types: ["hex", "hexa", "rgba", "hsla", "hsva"],
  //   type: "hex",
  //   hex: "#FF00FF",
  //   hexa: "#FF00FFFF",
  //   rgba: { r: 255, g: 0, b: 255, a: 1 },
  //   hsla: { h: 300, s: 1, l: 0.5, a: 1 },
  //   hsva: { h: 300, s: 1, v: 1, a: 1 },

  //   pickerColour: this.$store.getters.retrieveCustomThemePrimary,
  // }),

  data() {
    return {
      customTheme: false,
      types: ["hex", "hexa", "rgba", "hsla", "hsva"],
      type: "hex",
      hex: "#FF00FF",
      hexa: "#FF00FFFF",
      rgba: { r: 255, g: 0, b: 255, a: 1 },
      hsla: { h: 300, s: 1, l: 0.5, a: 1 },
      hsva: { h: 300, s: 1, v: 1, a: 1 },

      pickerColour: this.$store.getters.retrieveCustomThemePrimary,
    };
  },

  methods: {
    ...mapActions(["setCustomPrimaryColour"]),
  },

  computed: {
    primaryColour: {
      get() {
        return this.pickerColour;
      },
      set(v) {
        console.log("-- Setting Primary");
        this.pickerColour = v;
      },
    },

    theme() {
      return this.$vuetify.theme.dark ? "dark" : "light";
    },
  },

  watch: {
    // whenever colour changes, this function will run
    primaryColour: function (newPrimary) {
      this.setCustomPrimaryColour(newPrimary, this.theme);
    },

    // backgroundColour: function (newBackground) {
    //   this.$vuetify.theme.themes[this.theme].background = newBackground;
    //   this.$vuetify.theme.themes[this.theme].background_alt = newBackground;
    //   this.$vuetify.theme.themes[this.theme].background_off = newBackground;
    //   this.$vuetify.theme.themes[this.theme].footerColor = newBackground;
    // },
  },
};
</script>

<style lang="sass" scoped>
</style>